import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'

const Footer = () => {
    const today = new Date();
    const year = today.getFullYear();
    return (
        <section className='footer-section text-white py-5'>
            <div className='container'>
                <div className='row text-center'>
                    <h2 className='heading-three'>Let’s Talk?</h2>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" placeholder="Name" aria-label="name" />
                        <input type="text" class="form-control" placeholder="Subject" aria-label="subject" />
                        <input type="email" class="form-control" placeholder="Email" aria-label="email" />
                        <input type="number" class="form-control" placeholder="Phone" aria-label="number" />
                        <button className='btn special-btn text text-uppercase'>submit</button>
                    </div>
                    <ul class="nav justify-content-center ">
                        <li class="nav-item ">
                            <Link class="nav-link text-color" to='https://www.linkedin.com/in/md-nasim-reza-149ab3164' target='_blank'>LinkedIn</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link text-color" to='https://www.facebook.com/nasim.reza.589/' target='_blank'>Facebook</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link text-color" to="#">Youtube</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link text-color" to='https://twitter.com/nasimitjes' target='_blank'>Twitter</Link>
                        </li>
                    </ul>
                    <p>&copy; Md. Nasim Reza - {year}</p>
                </div>
            </div>
        </section>
    );
};

export default Footer;